import React from 'react'
import { Edit, useForm } from '@refinedev/antd'
import { Form, Select, Input } from 'antd'
import type { Tables } from '@muaa/shared'

type Rsvp = Tables<'rsvps'>

// Canonical RSVP status vocabulary (a DB CHECK constraint enforces this set):
// confirmed (default) · pending · waitlisted · cancelled.
const STATUS_OPTIONS = [
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'pending', label: 'Pending' },
  { value: 'waitlisted', label: 'Waitlisted' },
  { value: 'cancelled', label: 'Cancelled' },
]

export function RsvpEdit() {
  const { formProps, saveButtonProps, query } = useForm<Rsvp>()
  const record = query?.data?.data

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        {/* Display-only context so staff know which RSVP they're moving. */}
        <Form.Item label="Guests">
          <Input value={record?.guests != null ? String(record.guests) : '0'} disabled />
        </Form.Item>

        <Form.Item label="Meal">
          <Input value={record?.meal ?? '—'} disabled />
        </Form.Item>

        {/* The editable field: move a member between buckets. */}
        <Form.Item label="Status" name="status" rules={[{ required: true }]}>
          <Select options={STATUS_OPTIONS} placeholder="Select status" />
        </Form.Item>
      </Form>
    </Edit>
  )
}
